import { useRef } from "react";
import { DatePicker } from "rsuite";

const SCDatePicker = ({ oneTap = true, ...props }) => {
  const containerRef = useRef(null);

  return (
    <>
      <div ref={containerRef}>
        <DatePicker
          isoWeek
          oneTap={oneTap}
          placeholder="-"
          {...props}
          container={() => containerRef.current}
        >
          {props.children}
        </DatePicker>
      </div>
    </>
  );
};

export default SCDatePicker;
